import BaseApiRequest from "./BaseApiRequest";
import { CONSENT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class TermsAndConditionsRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {
    creditCheck: "",
    marketing: "",
    communication: "",
  };

  constructor(termsDetail) {
    super();
    this.body = termsDetail;
  }

  getMethod = () => this.method;

  getUrl = () => {
    return getCurrentUserParameters(CONSENT_URL);
  };

  getBody = () => this.body;
}
